




































import { Component, Inject, Prop } from 'vue-property-decorator';
import CreateListDataMixin from '@/mixin/ListDataMixin';
import { ProductEntity } from '@/entities/product.entity';
import ProductItemPc from '@/components/ViewComponent/Exchange/ProductItemPc.vue';
import { sidebarConfig } from '@/config/sidebar';
import CashIcon from '@/components/Helper/Icon/Svg/CashIcon.vue';

const joins = ['category', 'receiveInstruction'];

@Component<Index>({
  components: { CashIcon, ProductItemPc },
  watch: {
    categoryId(id) {
      if (id === 0) {
        this.filter = [];
        return;
      }
      this.filter = [['categoryId', '$eq', id]];
    },
  },
})
export default class Index extends CreateListDataMixin<ProductEntity>(
  'product',
  'product',
  joins,
) {
  @Prop({ type: Number, required: true })
  categoryId: number;

  @Inject('toggleSideDrawer')
  toggleSideDrawer!: () => any;

  // items: ProductEntity[] = [];

  get containerWidth(): string {
    return this.$vuetify.breakpoint.mobile
      ? '100%'
      : `calc(100% - ${sidebarConfig.width}px - 48px)`;
  }

  get itemStyle(): Partial<CSSStyleDeclaration> {
    let columnNumber = 1;
    console.log(this.$vuetify.breakpoint);
    if (this.$vuetify.breakpoint.sm) {
      columnNumber = 2;
    } else if (this.$vuetify.breakpoint.md) {
      columnNumber = 4;
    } else if (this.$vuetify.breakpoint.lg) {
      columnNumber = 5;
    } else if (this.$vuetify.breakpoint.xl) {
      columnNumber = 8;
    }
    return {
      flex: `0 0 calc(100% / ${columnNumber})`,
      maxWidth: `calc(100% / ${columnNumber})`,
    };
  }

  async created(): Promise<void> {
    const { id } = this.$route.params;
    if (id) {
      this.filter = [['categoryId', '$eq', id]];
    }
  }
}
